import React from 'react';
//import ImageUploader from '../../../../../_dashboard/partials/widgets/upload/ImageUploader'
import ImageUploader from './ImageUploader'
import { useIntl } from 'react-intl'

import { ID } from '../../../../../_dashboard/helpers';

interface Image {
    _id: ID;
    url: string;
    seoUrl?: string;
}
interface Translation {
    _id: string;
    sliderItem_id: string;
    language: string;
    text: string;
    description: string;
    buttonText: string;
    __v: number;
  }
  
interface SliderItem {
    _id: string;
    slider_id: string;
    image: Image;
    link: string;
    translations: Translation[];
    __v: number;
  }
  
interface ImageGalleryProps {
  items: SliderItem[];
  handleImageClick: (item: SliderItem) => void;
  handleDeleteImage: (item: SliderItem) => void;
  handleImageAdded: () => void;
  handleImageUploaded: (image: { url: string; _id: string }) => void; 
  hotelId?: string;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({
  items,
  handleImageClick,
  handleDeleteImage,
  handleImageAdded,
  handleImageUploaded,
  hotelId,
}) => {
    console.log('items',items)
  const intl = useIntl()

  return (
    <section className='gallery-section py-4'>
      <div className='gallery gallery-style'>
        {items.map((item, index) => (
          <div key={index} className='d-flex flex-row justify-content-space-between'>
            <img
              src={
                item.image.url.includes('/images/')
                  ? process.env.REACT_APP_API_URL_IMAGE + item?.image?.url
                  : item?.image?.url
              }
              alt={`Gallery ${index}`}
              className='border-image h-175px cursor-pointer'
              onClick={() => handleImageClick(item)}
            />
            <div className='d-flex flex-column justify-content-space-between'>
              <span
                className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                data-kt-image-input-action='remove'
                data-bs-toggle='tooltip'
                title='Remove icon'
              >
                <i
                  className='cursor-pointer bi bi-pencil-fill fs-7 btn btn-icon btn-circle btn-active-color-primary'
                  onClick={() => handleImageClick(item)}
                ></i>
              </span>
              <span
                className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                data-kt-image-input-action='remove'
                data-bs-toggle='tooltip'
                title='Remove icon'
              >
                <i
                  className='cursor-pointer bi bi-x fs-2 btn btn-icon btn-circle btn-active-color-primary'
                  onClick={() => handleDeleteImage(item)}
                ></i>
              </span>
            </div>
          </div>
        ))}
        {/*<ImageUploader
          onImageUpload={(file: any) => console.log('Image uploaded:', file)}
          onImageAdded={handleImageUploaded}
          uploadEndpoint='/images'
          hotelId={hotelId}
        />*/}
      <ImageUploader
        image={{ url: '/images/example.jpg', _id: '123' }}
        handleImageClick={handleImageAdded}
        placement='slider'
      />
      </div>
    </section>
  );
};

export default ImageGallery;